<div class="publishing-status-container">
  <header class="publishing-status-header">
    <evrideo-publishing-toolbar
      [searchQuery]="state.searchQuery()"
      [statusFilter]="state.statusFilter()"
      [dateRangeKey]="state.dateRangeKey()"
      [selectedCount]="state.selectedCount()"
      [isExportingToMam]="state.isExportingToMam()"
      [isDeleting]="state.isDeleting()"
      (searchChange)="onSearchChange($event)"
      (statusChange)="onStatusChange($event)"
      (dateRangeChange)="onDateRangeChange($event)"
      (startNew)="onAddNew()"
      (importToMam)="onImportToMam()"
      (deleteSelected)="onDeleteSelected()"
    ></evrideo-publishing-toolbar>
  </header>

  <div class="publishing-status-content">
    @if (state.isLoading()) {
      <div class="publishing-status-loading">Loading distribution events...</div>
    } @else if (state.error()) {
      <div class="publishing-status-error">
        <p>{{ state.error() }}</p>
        <button type="button" (click)="loadPage()">Reload</button>
      </div>
    } @else {
      <div class="publishing-status-body">
        <div class="publishing-status-scroll">
          <evrideo-publishing-grid
            [events]="state.items()"
            [selectedIds]="state.selectedIds()"
            [selectionDisabled]="state.isBatchBusy()"
            (selectionChange)="onSelectionChange($event)"
            (cancelled)="onPublicationCancelled()"
          ></evrideo-publishing-grid>
        </div>
        <evrideo-publishing-pagination-footer
          [total]="state.total()"
          [pageSize]="state.pageSize()"
          [pageIndex]="state.pageIndex()"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"
        ></evrideo-publishing-pagination-footer>
      </div>
    }
  </div>
</div>
